import { render, staticRenderFns } from "./qascoreitem.vue?vue&type=template&id=70232f51&"
import script from "./qascoreitem.vue?vue&type=script&lang=js&"
export * from "./qascoreitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports